import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

@Component({
    selector: 'app-tab',
    template: '',
    styleUrls: [],
    standalone: false
})
export class TabComponent {
  @Input() name: string;
  @Input() disabled: boolean;
  @Input() ariaLabel: string;
  @ContentChild(TemplateRef, { static: true }) contentTemplate: any;
}
